
const ADMIN_TOKEN_KEY = "adminToken";

export const login = (token) => {
  if (!token) return false;
  localStorage.setItem(ADMIN_TOKEN_KEY, token);
  localStorage.setItem('isLoggedIn', 'true');
  return true;
};

export const logout = () => {
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  localStorage.removeItem('userEmail');
};

export const isLoggedIn = () => {
  return localStorage.getItem('isLoggedIn') === 'true' && localStorage.getItem(ADMIN_TOKEN_KEY);
};

export const getCurrentUser = () => {
  return localStorage.getItem('userEmail');
};

export const getToken = () => {
  return localStorage.getItem(ADMIN_TOKEN_KEY);
};

export const getAdminAuthHeader = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Opens a protected file without putting the access token in the URL.
export const openAuthenticatedFile = async (fileUrl) => {
  if (!fileUrl) throw new Error('No file URL was provided.');

  const response = await fetch(fileUrl, {
    method: 'GET',
    headers: getAdminAuthHeader(),
  });

  if (!response.ok) {
    const error = new Error(
      response.status === 401 || response.status === 403
        ? 'You are not authorized to view this file.'
        : 'Unable to open this file. Please try again.'
    );
    error.status = response.status;
    throw error;
  }

  const blobUrl = URL.createObjectURL(await response.blob());
  window.open(blobUrl, '_blank', 'noopener,noreferrer');
  window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
};
